import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { DrivePickerService } from '../../common/services/drive-picker/drive-picker.service';
import * as DrivePickerActions from './drive-picker.actions';

@Injectable()
export class DrivePickerEffects {
  private actions$ = inject(Actions);
  private drivePickerService = inject(DrivePickerService);

  openPicker$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DrivePickerActions.openDrivePicker),
      switchMap(() =>
        this.drivePickerService.openPicker().pipe(
          map((file) =>
            file
              ? DrivePickerActions.drivePickerFileSelected({ file })
              : DrivePickerActions.drivePickerCancelled()
          ),
          catchError((error: unknown) =>
            of(
              DrivePickerActions.drivePickerError({
                error:
                  error instanceof Error
                    ? error.message
                    : 'Failed to open Drive Picker',
              })
            )
          )
        )
      )
    )
  );
}
